import { ComponentBase } from "../ComponentBase";
import { getSymbolData } from "../../../../backend/src/common/stock/invoiceProductServices";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class CreateProduct extends ComponentBase {
    @Prop({ default: "" }) id: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) actions: any;

    quantityTypes = [
        { value: "QUANTITY", text: "Quantité" },
        { value: "MASS", text: "Masse" },
        { value: "LENGTH", text: "Longueur" },
        { value: "AREA", text: "Surface" },
        { value: "VOLUME", text: "Volume" },
    ];

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get activateTagguing() {
        return true;
    }

    tag = null;

    async onTagsChanged(data) {
        if (data.tags?.length === 1) {
            this.tag = data.tags[0];
        } else {
            this.tag = null;
        }
    }

    physicalQuantities = {
        QUANTITY: "mesure",
        MASS: "masse",
        LENGTH: "longueur",
        AREA: "surface",
        VOLUME: "volume",
    };

    getUnitOfMeasureLabel(quantityType) {
        return "Unité de " + this.physicalQuantities[quantityType];
    }

    getSymbolData(product) {
        return getSymbolData(product);
    }
}
